import React from 'react';
import { Button } from '../../library/Button';
import PhotoChecklist from './PhotoChecklist';
import PhotoImagePanel from './PhotoImagePanel';
import { ActionRow, PreviewPanel } from './ProfilePictureUpload.styles';
import { PHOTO_STAGES } from './utils';

/**
 * Second screen of the dialog, covering every CAPTURE_STAGES stage. Pairs the
 * checklist with the live/preview image and the Back/Submit actions.
 * `canSubmit` is decided by the dialog, so the button can't disagree with the
 * checklist beside it.
 */
function PhotoCapturePreview({
    stage,
    isMobile,
    photoUrl,
    localChecks,
    biostarError,
    videoRef,
    canvasRef,
    canSubmit,
    onCapture,
    onBack,
    onSubmit,
}) {
    return (
        <>
            <PreviewPanel $isMobile={isMobile}>
                <PhotoChecklist localChecks={localChecks} biostarError={biostarError} stage={stage} />
                <PhotoImagePanel
                    stage={stage}
                    photoUrl={photoUrl}
                    videoRef={videoRef}
                    canvasRef={canvasRef}
                    onCapture={onCapture}
                />
            </PreviewPanel>

            <ActionRow>
                <Button $variant="secondary" type="button" onClick={onBack}>
                    <i className="fal fa-chevron-left"></i> Back
                </Button>
                <Button type="button" onClick={onSubmit} disabled={!canSubmit}>
                    {stage === PHOTO_STAGES.SUBMITTING ? (
                        <i className="fas fa-cog fa-spin"></i>
                    ) : (
                        <>
                            <i className="fal fa-check"></i> Submit
                        </>
                    )}
                </Button>
            </ActionRow>
        </>
    );
}

export default PhotoCapturePreview;
